import {
  SET_MODELS,
  SET_IS_LOADING_PERCENTAGE,
  SET_IS_TWIN_LOADING,
  SET_IS_TWIN_READY,
  SET_LAST_SELECTED_LAYER,
} from '../actions/actionTypes';
import { DigitalTwinAction, DigitalTwinStateType } from '../context';

export default (
  state: DigitalTwinStateType,
  action: DigitalTwinAction,
): DigitalTwinStateType => {
  switch (action.type) {
    case SET_IS_TWIN_READY:
      return {
        ...state,
        isTwinReady: action.payload,
      };
    case SET_IS_TWIN_LOADING:
      return {
        ...state,
        isTwinLoading: action.payload,
      };
    case SET_LAST_SELECTED_LAYER:
      return {
        ...state,
        lastSelectedLayer: action.payload,
      };
    case SET_IS_LOADING_PERCENTAGE:
      return {
        ...state,
        loadingPercentage: action.payload,
      };
    case SET_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    default:
      return state;
  }
};
